export default class ErrorPageModel {
  constructor({ title, subtitle, description }) {
    this.title = title;
    this.subtitle = subtitle;
    this.description = description;
  }
}
